import { __rest } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 Links are an accessible element for navigation, internal or external.

 @see {@link https://storybook.medable.tech/nucleus-components/?path=/docs/link--basic} for Storybook documentation
 @see {@link https://www.figma.com/file/F4k8k8CQY83kziWjGDQmXc/Nucleus-Product-Styles?type=design&node-id=79-8779&t=Q6Ty51n9tc7XsZBA-0} for Nucleus design
 @see {@link https://www.w3.org/WAI/ARIA/apg/patterns/link/} for best accessibilty patterns
*/
export const Link = (_a) => {
    var { disabled, onClick, variant = 'default', children, customStyles, LinkComponent = 'a' } = _a, props = __rest(_a, ["disabled", "onClick", "variant", "children", "customStyles", "LinkComponent"]);
    const handleClick = (event) => {
        if (disabled) {
            event.preventDefault();
        }
        else if (onClick) {
            onClick(event);
        }
    };
    const defaultStyles = `nucleus-box-border nucleus-cursor-pointer nucleus-font-sans nucleus-text-sm nucleus-font-medium nucleus-text-primary-500 nucleus-underline hover:nucleus-text-primary-700 focus:nucleus-ring-primary-500 active:nucleus-text-text-primary focus:nucleus-outline-none focus:nucleus-ring-2 focus:nucleus-ring-offset-2 ${disabled ? 'nucleus-pointer-events-none nucleus-text-text-disabled' : ''}`;
    return (_jsxs(_Fragment, { children: [variant === 'default' && (_jsx(LinkComponent, Object.assign({}, props, { onClick: handleClick, className: defaultStyles, children: children }))), variant === 'custom' && (_jsx(LinkComponent, Object.assign({}, props, { onClick: handleClick, className: customStyles, children: children })))] }));
};
//# sourceMappingURL=link.js.map